export default __webpack_public_path__ + "static/media/016-portugal cross.a4742827.svg";